/**
 * Single aligned strip for messages + composer + welcome (~48rem / 768px cap).
 * Keeps markdown and input edges vertically aligned.
 */
export const CHAT_ALIGNED_MAX_WIDTH = "max-w-[min(100%,48rem)]";

/** Used by ConversationStarters and legacy imports — same cap as the chat strip. */
export const CHAT_LAYOUT_MAX_WIDTH = CHAT_ALIGNED_MAX_WIDTH;

/** Centered column: thread messages, welcome shell, composer (same width). */
export const CHAT_COLUMN_CLASS = `w-full ${CHAT_ALIGNED_MAX_WIDTH} mx-auto`;

export const CHAT_COMPOSER_COLUMN_CLASS = CHAT_COLUMN_CLASS;

/**
 * Assistant / streaming text — full width of the column beside the avatar (no 85% taper).
 */
export const CHAT_ASSISTANT_CONTENT_CLASS = "w-full min-w-0";

/** User bubble — stays slightly narrower than assistant on wide layouts. */
export const CHAT_USER_BUBBLE_CLASS =
  "max-w-[88%] sm:max-w-[80%] lg:max-w-[72%] xl:max-w-[68%]";
